import { api } from '../../app/api'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'


const authErrorMessage = (error, fallback) => {
  const data = error?.response?.data
  if (typeof data === 'string' && data.trim()) return data
  if (data?.message) return data.message
  if (error?.message) return error.message
  return fallback
}

export const sendSms = createAsyncThunk(
  'login/sendSms',
  async ({ phoneNumber }, { rejectWithValue }) => {
    try {
      const response = await api.post('send-sms', { phoneNumber, device_name: 'web' });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        authErrorMessage(error, 'Не удалось отправить код. Попробуйте позже.')
      );
    }
  }
)

export const sendCall = createAsyncThunk(
    'login/call',
    async ({ phoneNumber }, { rejectWithValue }) => {
      try {
        const response = await api.post('auth/incoming-call/start', { phoneNumber, device_name: 'web' });
        return response.data
      } catch (error) {
        return rejectWithValue(
          authErrorMessage(error, 'Не удалось начать звонок. Попробуйте позже.')
        );
      }
    }
)

export const checkUser = createAsyncThunk(
  'login/checkUser',
  async ({ token }) => {
    api.defaults.headers = {
      Authorization: `Bearer ${token}`
    }
    const response = await api.get('/user')
    return response.data
  }
)
export const createUser = createAsyncThunk(
  'login/createUser',
  async () => {
    const response = await api.post('auth/create', { phoneNumber: '', email: 'sirykey@gmail.com', smsCode: '6117', name: 'Рамзан' })
    return response.data
  }
)
export const fetchToken = createAsyncThunk(
  'login/fetchToken',
  async ({ phoneNumber, code,confirmationNumber }) => {
    // api.defaults.headers = {
    //   Authorization: `Bearer ${token}`
    // }
    const response = await api.post('auth/incoming-call/create-token', { phoneNumber,confirmationNumber, code, device_name: 'web' });
    // const response = await api.post('sanctum/token-by-password', { phoneNumber: "79221110500", "password" : "12345678",
    //      device_name: 'postman' });
    return response.data;
  },
)
export const fetchSMSToken = createAsyncThunk(
    'login/fetchToken',
    async ({ phoneNumber, smsCode }) => {
      // api.defaults.headers = {
      //   Authorization: `Bearer ${token}`
      // }
      const response = await api.post('sanctum/token', { phoneNumber, smsCode, device_name: 'web' });
      // const response = await api.post('sanctum/token-by-password', { phoneNumber: "79221110500", "password" : "12345678",
      //      device_name: 'postman' });
      return response.data;
    },
)
const loginSlice = createSlice({
  name: 'login',
  initialState: {
    isLoaded: false,
    isTokenLoaded: false,
    loggedIn: false,
    phoneNumber: '',
    token: localStorage.getItem('token'),
    numberForCall: '',
    numberLoading: false,
    error: {
      failed: false,
      message: null,
    },
  },
  reducers: {
    setUserNumber(state, action) {
      state.phoneNumber = action.payload
      console.log('ph', action.payload)
    }
  },
  extraReducers: {
    [sendSms.pending]: (state) => {
      state.isLoaded = false;
      state.error.failed = false;
      state.error.message = null;
    },
    [sendSms.fulfilled]: (state) => {
      state.isLoaded = true;
    },
    [sendSms.rejected]: (state, action) => {
      state.isLoaded = false;
      state.error.message = action.payload;
      state.error.failed = true;
    },
    [checkUser.pending]: (state) => {
      state.isLoaded = false;
      state.error.failed = false;
      state.error.message = null;
    },
    [checkUser.fulfilled]: (state) => {
      state.isLoaded = true;
      state.loggedIn = true;
    },
    [checkUser.rejected]: (state, action) => {
      state.isLoaded = true;
      state.error.message = action.payload;
      state.error.failed = true;
    },
    [fetchToken.pending]: (state) => {
      state.isTokenLoaded = false;
      state.error.failed = false;
      state.error.message = null;
    },
    [fetchToken.fulfilled]: (state, action) => {
      state.isTokenLoaded = true;
      state.token = action.payload.token
      localStorage.setItem('token', action.payload.token)
    },
    [fetchToken.rejected]: (state, action) => {
      state.isTokenLoaded = true;
      state.error.message = action.payload;
      state.error.failed = true;
    },
    [sendCall.pending]: (state) => {
      state.numberLoading = true;
      state.error.failed = false;
      state.error.message = null;
    },
    [sendCall.fulfilled]: (state, action) => {
      state.numberLoading = true;
      state.numberForCall = action.payload
    },
    [sendCall.rejected]: (state, action) => {
      state.numberLoading = false;
      state.error.message = action.payload;
      state.error.failed = true;
    },
  }
})
export const { setUserNumber } = loginSlice.actions
export default loginSlice.reducer
